<template>
  <div class="text-center" style="padding-top: 72px">
    <span class="block font-semibold text-lg text-gray-92 leading-8 mb-8">
      お探しのページは見つかりませんでした
    </span>
    <div class="font-light text-gray-92 leading-6 mb-12">
      <span class="block">アクセスしようとしたページが見つかりません。</span>
      <span class="block"
        >ご指定のページは削除されたか、移動した可能性がございます。</span
      >
    </div>
    <!-- TODO: 遷移先修正？ -->
    <a
      href="https://imitsu-cloud.jp/"
      target="_blank"
      class="font-semibold text-white text-center bg-secondary-main leading-5 rounded"
      style="padding: 10px 30px"
    >
      サービス紹介ページへ
    </a>
  </div>
</template>

<script>
export default {
  setup() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped></style>
